import styled from 'styled-components';

export const TextInput = styled.input`
  background: var(--white);
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: var(--shadow-inset-sm);
  color: var(--grey-600);
  font-family: var(--raleway);
  font-size: 13px;
  padding: 0.4rem 0.8rem;
  transition:
    border 0.15s,
    background 0.15s,
    box-shadow 0.15s;
  width: 100%;
  &::placeholder {
    color: var(--grey-600);
  }
  &:focus {
    background: var(--grey-75);
    border: 1px solid var(--grey-700);
    box-shadow: none;
    outline: none;
  }
`;

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin: 0 auto;
  max-width: 1000px;
  row-gap: 0.5rem;
`;

export const FilterRow = styled.div`
  align-items: center;
  display: flex;
  width: 100%;

  /* Stack label above field on mobile so the input can't clip off-edge */
  @media (max-width: 768px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const DateRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  width: 100%;

  /* Stack the paired date pickers instead of clipping the second one */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

export const DateCol = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  min-width: 0;

  @media (max-width: 768px) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export type FilterFieldType =
  | 'text'
  | 'select'
  | 'multiselect'
  | 'date'
  | 'checkbox';

export interface FilterFieldOption {
  value: string;
  label: string;
}

export interface FilterField {
  key: string;
  label: string;
  type: FilterFieldType;
  options?: FilterFieldOption[]; // for 'select' type filters
  placeholder?: string;
  colSpan?: number;
  groupWith?: string; // key of another field to group with side-by-side
  checkboxLabel?: string; // for 'checkbox' type - text that appears after the checkbox
}

export const ButtonGroup = styled.div`
  align-items: center;
  display: flex;
  gap: 1rem;
`;

// Collapsible panel (used for filter/settings panels)
export const Panel = styled.div<{
  isOpen: boolean;
  panelType?: string;
  maxHeight?: string;
}>`
  background: ${(props) => (props.isOpen ? 'var(--white)' : 'transparent')};
  border: ${(props) => (props.isOpen ? '1px solid var(--grey-300)' : 'none')};
  border-radius: ${(props) => (props.isOpen ? '8px' : '0')};
  margin: ${(props) => (props.isOpen ? '0 0.9rem 1.1rem' : '0')};
  max-height: ${(props) => props.maxHeight || '0px'};
  overflow: hidden;
  pointer-events: ${(props) => (props.isOpen ? 'auto' : 'none')};
  transition: max-height 0.3s ease;
`;

export const PanelContent = styled.div`
  padding: 2rem;
`;

export const Label = styled.label`
  color: var(--black);
  font-size: 13px;
  margin-right: 1rem;
  min-width: 160px;
  white-space: nowrap;

  /* Drop the fixed width when stacked so it no longer eats horizontal space */
  @media (max-width: 768px) {
    margin-bottom: 0.35rem;
    margin-right: 0;
    min-width: 0;
    white-space: normal;
  }
`;
